import { IconButton, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { PlusIcon } from '@tom-ui/ui'

interface Props {
  canAdd: boolean
  onAdd: () => void
  dataCy?: string
}
export const OperationalEquipmentAdd = ({ canAdd, onAdd, dataCy }: Props) => {
  const { t } = useTranslate()

  if (!canAdd) return <></>

  return (
    <Tooltip title={t('add', 'Add')}>
      <IconButton onClick={onAdd} data-cy={dataCy}>
        <PlusIcon />
      </IconButton>
    </Tooltip>
  )
}
